<template>
  <div>

  </div>
</template>

<script>
  export default {

  };
</script>

<style lang="scss" scoped>
  .next-steps {
    .fa-link {
      margin-right: 5px;
    }
  }
</style>